import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "./activity";

export default function ActivityTracker() {
  const loc = useLocation();

  useEffect(() => {
    trackPageView(loc.pathname + loc.search, document.title);
  }, [loc.pathname, loc.search]);

  return null;
}
